<template>
  <footer class="footer-container">
    <div class="container-footer-all">
      <div class="container-body">
        <div class="colum1">
          <div class="row">
            <div class="footer-menu">
              <router-link to="/">
                Home
              </router-link>
            </div>
            <div class="footer-menu">
              <router-link to="/medium">
                Blog
              </router-link>
            </div>
            <div class="footer-menu">
              <router-link to="/about">
                About
              </router-link>
            </div>
            <div class="footer-menu">
              <router-link to="/terms">
                Terms of Services
              </router-link>
            </div>
            <div class="footer-menu">
              <a
                href="https://www.kulap.io/annual-financial-statements.html"
                target="_blank"
              >
                Annual financial statements
              </a>
            </div>
            <div class="footer-menu">
              <a
                :href="`${s3BucketKulapUtilityFileUrl}/pdf/รายชื่อศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่เชื่อมต่อการซื้อขาย.pdf`"
                target="_blank"
              >
                List of sourced exchange
              </a>
            </div>
            <div class="footer-menu">
              <a
                :href="`${s3BucketKulapUtilityFileUrl}/pdf/quality-of-service-information.pdf`"
                target="_blank"
              >
                Quality of service information
              </a>
            </div>

          </div>
          <div class="row">
            <img
              class="kulap-logo"
              src="/static/svg/kulap-logo-white.svg"
            >
          </div>
          <div class="row">
            <div class="kulap-desc-desktop">
              2018-2021 Satoshi Co.,Ltd.All Rights Reserved.
            </div>
          </div>
        </div>
        <div class="colum2">
          <div class="footer-copyright">
            <div class="footer-copyright-body">
              <div class="footer-icon">
                <router-link to="/facebook">
                  <img src="/static/svg/facebook.svg">
                </router-link>
                <router-link to="/medium">
                  <img src="/static/svg/medium.svg">
                </router-link>
                <router-link to="/youtube">
                  <img src="/static/svg/youtube.svg">
                </router-link>
                <router-link to="/linkedin">
                  <img src="/static/svg/linkedin.svg">
                </router-link>
                <router-link to="/instagram">
                  <img src="/static/svg/instagram.svg">
                </router-link>
                <router-link to="/twitter">
                  <img src="/static/svg/twitter.svg">
                </router-link>
              </div>
            </div>
          </div>
          <p class="kulap-desc-mobile">
            2018-2021 Satoshi Co.,Ltd.All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getS3BucketKulapUtilityFileUrl } from '@/environments'
/**
 * Footer Component
 */
export default {
  name: 'Footer',
  data () {
    return {
      s3BucketKulapUtilityFileUrl: getS3BucketKulapUtilityFileUrl()
    }
  }
}
</script>

<style scoped>
a {
  color: #ffffff;
  text-decoration: none;
}

a:link,
a:visited {
  color: #ffffff;
  text-decoration: none;
}

.footer-menu:hover {
  color: #ffffff;
  text-decoration: none;
}

.footer-container {
  width: 100%;
  background: #0559af;
  color: white;
  padding: 28px;
  height: auto;
  margin-top: 60px;
}

.container-footer-all {
  width: 100%;
  max-width: 1450px;
  margin: auto;
}

.container-body {
  display: flex;
  justify-content: space-between;
}

.colum1 {
  max-width: 730px;
  margin-left: 40px;
}

.colum1 h1 {
  font-size: 16px;
}

.colum1 p {
  margin-top: 17px;
  font-size: 14px;
  color: #ffffff;
}

.colum2 {
  max-width: 800px;
  display: flex;
  align-items: flex-end;
}

.colum2 h1 {
  font-size: 15px;
  margin-right: 41px;
}

.row {
  display: flex;
  color: white;
}

.row img {
  width: 35px;
  height: 35px;
}

.row label {
  margin-top: 10px;
  margin-left: 10px;
  color: #c7c7cc;
}

.container-footer {
  width: 100%;
  background: #101010;
  padding: 20px;
}

.footer {
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.footer-menu a {
  color: white;
  cursor: pointer;
  text-decoration: none;
  font-size: 15px;
  font-weight: bold;
}

.footer-menu a:hover {
  text-decoration: underline;
}

.subscribe {
  margin-top: 20px;
  display: flex;
}

.subscribe input {
  border-top-right-radius: 0%;
  border-bottom-right-radius: 0%;
  width: 80%;
  text-align: center;
}

.subscribe button {
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
  width: 20%;
  background-color: #00aeff;
}

.footer-copyright {
  right: 0px;
  width: 100%;
}

.footer-copyright img {
  margin-right: 32px;
  width: 50px;
  height: 50px;
}

.footer-icon img {
  cursor: pointer;
}

.footer-copyright img:hover {
  opacity: 0.5;
}

.footer-copyright-body {
  float: right;
  height: max-content;
}

.footer-menu {
  margin-right: 50px;
}

.kulap-desc-desktop {
  font-size: 13px;
  margin-top: 10px;
}

.kulap-desc-mobile {
  display: none;
}

.kulap-logo {
  width: 200px !important;
  height: auto !important;
  margin-top: 42px;
}

/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .footer-container {
    margin-top: 28px;
    padding: 8px;
  }

  .container-footer-all {
    margin-top: 20px;
  }

  .container-body {
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0 15px 0 15px;
  }

  .colum1 {
    max-width: 100%;
    margin-left: unset;
  }

  .colum2 {
    margin: 30px 0 5px;
    width: 100% !important;
    padding: 0 0px 0 0px !important;
    color: #ffffff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .colum3 {
    margin: 30px 0 5px;
    width: 100% !important;
    padding: 0 0px 0 0px !important;
    color: #ffffff;
    text-align: center;
  }

  .row {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: flex-start;
    flex-flow: row wrap;
    align-content: flex-start;
    width: 100%;

  }

  .row>* {
    flex: 1 1 calc(30% - 10px);
  }

  .row h1:nth-child(even) {
    text-align: left;
    padding-left: 10%;
  }

  .row h1:nth-child(odd) {
    text-align: left;
    padding-left: 30%;
  }

  .footer-copyright-body {
    width: 100%;
    text-align: center;
  }

  .footer-copyright img {
    margin: 5px 15px 0 0;
  }

  .footer-menu {
    margin-top: 10px;
    margin-right: 30px;
  }

  .kulap-logo {
    display: none;
  }

  .kulap-desc-desktop {
    display: none;
  }

  .kulap-desc-mobile {
    display: block;
    font-size: 13px;
    margin: 35px 0;
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .colum2 {
    width: 100% !important;
  }

  .row {
    font-weight: bold;
    font-size: 12px;
  }

  .row>* {
    flex: 1 1 calc(30% - 10px);
  }

  .row h1:nth-child(even) {
    padding-left: 10%;
    /* background: red; */
  }

  .row h1:nth-child(odd) {
    padding-left: 30%;
  }

  .footer-copyright img {
    margin-right: 15px;
  }

  .subscribe span {
    font-size: 12px;
  }

  .subscribe button {
    z-index: 2;
  }
}
</style>

<docs>
```js
  <Footer/>
```
</docs>



// WEBPACK FOOTER //
// src/components/Footer.vue